export function parseJwt(token) {
    return JSON.parse(atob(token.split('.')[1]));
}
export function generateString(length = 32) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
export function arrayBufferLikeCopy(arrayBufferLike) {
    if (ArrayBuffer.isView(arrayBufferLike)) {
        return arrayBufferLike.buffer.slice(arrayBufferLike.byteOffset, arrayBufferLike.byteOffset + arrayBufferLike.byteLength);
    }
    else {
        return arrayBufferLike.slice(0);
    }
}
export function Uint8ArrayToHex(array) {
    if (array === null || typeof array === 'undefined')
        return null;
    if (!(array instanceof Uint8Array))
        throw new Error('invalid argument: array.type=' + typeof array);
    return Array.from(array).map((i) => i.toString(16).padStart(2, '0')).join('');
}
export function hexToUint8Array(hex) {
    if (typeof hex != 'string')
        throw new Error('invalid argument: hex.type=' + typeof hex);
    if (hex.length % 2 != 0)
        throw new Error('invalid argument: hex.length=' + hex.length);
    const array = new Uint8Array(hex.length / 2);
    for (let i = 0, j = 0; i < array.length; ++i, j += 2) {
        array[i] = Number('0x' + hex.substring(j, j + 2));
    }
    return array;
}
export function mergeUint8ArraysIf(arrays) {
    if (arrays.length == 0)
        return null;
    if (arrays.length == 1)
        return arrays[0];
    let length = 0;
    for (let i = 0; i < arrays.length; ++i) {
        length += arrays[i].byteLength;
    }
    const ret = new Uint8Array(length);
    for (let i = 0, j = 0; i < arrays.length; ++i) {
        ret.set(arrays[i], j);
        j += arrays[i].length;
    }
    return ret;
}
export function removeTransceiverByMid(sdp, mids) {
    const lines = sdp.split('\r\n');
    const midSet = new Set(mids);
    let currentMid = null;
    let firstMid = null;
    let updatedLines = [];
    let lastMlineIndex = -1, lastDirectionIndex = -1;
    let lamda = () => {
        if (currentMid && midSet.has(currentMid)) {
            if (currentMid != firstMid) {
                const mLineParts = updatedLines[lastMlineIndex].split(' ');
                mLineParts[1] = '0';
                updatedLines[lastMlineIndex] = mLineParts.join(' ');
            }
            updatedLines[lastDirectionIndex] = 'a=inactive';
            lastMlineIndex = lastDirectionIndex = -1;
        }
    };
    for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        /* if (line.startsWith('a=group:BUNDLE')) {
             const bundleMids = line
                 .split(' ')
                 .slice(1)
                 .filter(mid => !midSet.has(mid));
             updatedLines.push(`a=group:BUNDLE ${bundleMids.join(' ')}`);
             continue;
         }*/
        if (line.startsWith('m=')) {
            lamda();
            currentMid = null;
            lastMlineIndex = updatedLines.length;
            updatedLines.push(line);
            continue;
        }
        if (line.startsWith('a=mid:')) {
            currentMid = line.substring(6).trim();
            if (!firstMid) {
                firstMid = currentMid;
            }
        }
        if (currentMid && midSet.has(currentMid)) {
            if (line.startsWith('a=ssrc') || line.startsWith('a=ssrc-group')) {
                continue;
            }
            if (line.match(/^a=(sendrecv|sendonly|recvonly|inactive)$/)) {
                lastDirectionIndex = updatedLines.length;
                updatedLines.push(line);
                continue;
            }
            updatedLines.push(line);
        }
        else {
            updatedLines.push(line);
        }
    }
    lamda();
    return updatedLines.join('\r\n');
}
export const workerMaker = (code, config = {}) => {
    let blob;
    try {
        blob = new Blob([code], { type: 'application/javascript' });
    }
    catch (e) {
        // Backwards-compatibility
        //@ts-ignore
        window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;
        //@ts-ignore
        blob = new BlobBuilder();
        blob.append(code);
        blob = blob.getBlob();
    }
    return new Worker(URL.createObjectURL(blob), config);
};
export const sharedWorkerMaker = (code, config = {}) => {
    let blob;
    try {
        blob = new Blob([code], { type: 'application/javascript' });
    }
    catch (e) {
        // Backwards-compatibility
        //@ts-ignore
        window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;
        //@ts-ignore
        blob = new BlobBuilder();
        blob.append(code);
        blob = blob.getBlob();
    }
    return new SharedWorker(URL.createObjectURL(blob), config);
};
export const liveParamBuilder = (camera, streamId) => {
    const streamObj = {
        cameraMac: camera.macAddress,
        remoteIndex: camera.remoteIndex,
        streamId,
        videoInfo: {
            width: camera.subStream?.resolution?.width ||
                camera.mainStream?.resolution?.width || 720,
            height: camera.subStream?.resolution?.height ||
                camera.mainStream?.resolution?.height || 640,
            fps: camera.subStream?.frameRate ||
                camera.mainStream?.frameRate || 25,
        },
    };
    return streamObj;
};
export const playbackParamBuilder = (camera, streamId, startAt, endAt) => {
    const streamObj = {
        cameraMac: camera.macAddress,
        remoteIndex: camera.remoteIndex,
        streamId,
        videoInfo: {
            width: camera.subStream?.resolution?.width ||
                camera.mainStream?.resolution?.width || 720,
            height: camera.subStream?.resolution?.height ||
                camera.mainStream?.resolution?.height || 640,
            fps: camera.subStream?.frameRate ||
                camera.mainStream?.frameRate || 25,
        },
        startAt,
        endAt,
        channelId: camera.channelId,
    };
    return streamObj;
};
export var DEVICE_TYPE;
(function (DEVICE_TYPE) {
    DEVICE_TYPE["CAMERA_AUDIO"] = "ip_camera";
    DEVICE_TYPE["SPEAKER_AUDIO"] = "ip_speaker";
})(DEVICE_TYPE || (DEVICE_TYPE = {}));
export const audioParamBuilder = (camera, deviceType) => {
    const streamObj = {
        macAddress: camera.macAddress,
        remoteIndex: camera.remoteIndex,
        deviceType,
    };
    return streamObj;
};
